module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": _vm.toInvoiceAdd
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-address-add@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("添加发票信息")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "address_list"
  }, _vm._l((_vm.invoiceList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "address_info",
      on: {
        "click": function($event) {
          return _vm.InvoiceEdit(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "header"
    }, [_c('h1', [_vm._v(_vm._s(item.taitou))])]), _vm._v(" "), _c('div', {
      staticClass: "body"
    }, [_vm._v(_vm._s(item.shuihao))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458a45d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/invoice/InvoiceList.vue
// module id = 2335
// module chunks = 0